import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { transition, variants } from './variants';
import { useClickOutside } from '../../../utils/hooks/useClickOutside';
import { useNavigation } from '../../../utils/NavigationContext';
import { useWindowSize } from '../../../utils/hooks/useWindowSize';
import styles from './QrDisplayMenu.module.css';

export default function QrDisplayMenu(props) {

    const { categoryOrder, editOrder, setEditOrder, categoryStates, setCategoryStates, setFilters } = props;

    const { collectionMenuRef, showCollectionMenu } = useNavigation();
    const { width } = useWindowSize();

    const categoriesBtnRef = useRef(null);
    const [ categoriesRef, showCategories, setShowCategories ] = useClickOutside(false, categoriesBtnRef);
    const [ allCollapsed, setAllCollapsed ] = useState(Object.values(categoryStates).every(item => item === false));

    const handleTop = (e) => {
        e.preventDefault();
        window.scroll({top: 0, behavior: 'smooth'});
    };

    const handleShowCategorySelect = () => {
        setShowCategories(!showCategories);
        setFilters(prev => ({...prev, searchValue: ''}));
    };

    const handleSelect = (e) => {
        const btnType = e.target.id;
        const header = document.getElementById(btnType);
        const position = header.offsetTop;
        window.scrollTo({ top: position, behavior: 'smooth' });
        setShowCategories(false);
    };

    const handleCollapse = (bool) => {
        setCategoryStates(prev => {
            const next = {};
            Object.keys(prev).forEach(key => {
                next[key] = bool
            });
            return next;
        });
        setFilters(prev => ({...prev, searchValue: ''}));
    };

    const handleEditOrder = (bool) => {
        setEditOrder(!bool);
        setFilters(prev => ({...prev, searchValue: ''}));
    };

    useEffect(() => {
        setAllCollapsed(Object.values(categoryStates).every(item => item === false));
    },[categoryStates]);

    return (
        <AnimatePresence initial={false}>
            {((showCollectionMenu || width > 500) &&
                <motion.div
                    key='collection-menu'
                    className={styles.wrapper}
                    transition={transition}
                    variants={variants}
                    initial='hideMenu'
                    animate='showMenu'
                    exit='hideMenu'
                    ref={collectionMenuRef}
                    custom={width}
                >
                    <div className={styles.container}>
                        <button 
                            type='button'
                            className={`${styles.btn} ${showCategories ? styles.selected : null}`} 
                            onClick={handleShowCategorySelect} 
                            disabled={editOrder}
                            title={showCategories ? 'Close Menu' : 'Open Menu'}
                            ref={categoriesBtnRef}
                        >
                            <i className={`${showCategories ? 'far fa-xmark' : 'fak fa-sidemenu'}`} style={{pointerEvents: 'none'}} />
                            {width <= 500 && (<span>Categories</span>)}
                        </button>
                        <button
                            type='button'
                            className={`${styles.btn} ${allCollapsed ? styles.selected : null}`}
                            onClick={() => handleCollapse(allCollapsed)}
                            disabled={editOrder}
                            title={allCollapsed ? 'Expand Sections' : 'Collapse Sections'}
                        >
                            <i className={`far fa-${allCollapsed ? 'arrows-from-line' : 'arrows-to-line'}`} />
                            {width <= 500 && (<span>Collapse</span>)}
                        </button>
                        <button
                            type='button'
                            className={`${styles.btn} ${editOrder ? styles.selected : null}`}
                            onClick={() => handleEditOrder(editOrder)}
                            title={editOrder ? 'Stop Reorder' : 'Start Reorder'}
                        >
                            <i className={`${editOrder ? 'far fa-xmark' : 'fak fa-reorder'}`} />
                            {width <= 500 && (<span>Reorder</span>)}
                        </button>
                        <button className={styles.btn} id='to-top' title='Top of Page' onClick={handleTop}>
                            <i className='far fa-arrow-up' />
                            {width <= 500 && (<span>To Top</span>)}
                        </button>
                    </div>
                    <AnimatePresence mode='wait' initial={false}>
                        {showCategories && (
                            <motion.div 
                                key='display-menu'
                                className={styles.selectWrap}
                                transition={transition}
                                variants={variants}
                                initial='hideCategories'
                                animate='showCategories'
                                exit='hideCategories'
                                ref={categoriesRef}
                                custom={width}
                            >
                                <div className={styles.select} id='cat-select'>
                                    <div className={styles.selectHeader}><span>Select Category</span></div>
                                    <div className={styles.selectInner}>
                                        {categoryOrder.map((cat, i) => (
                                            <div id={cat.id} key={i} className={styles.selectOption} onClick={handleSelect}>{cat.name}</div>
                                        ))}
                                    </div>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </motion.div>
            )}
        </AnimatePresence>
    );
};